// FILE: /src/store/Slices/ProfileSlice.jsx (UPDATED)

import { createSlice } from "@reduxjs/toolkit";

const ProfileSlice=createSlice({
    name:"ProfileSlice",
    initialState:[],
    reducers:{
        ProfileRedu(state,action){
            state.length=0          
            state.push(action.payload)
        },
        // --- START: ADD THIS NEW REDUCER ---
        updateUserPlanStatus(state, action) {
            if (state[0]) {
                state[0].is_active_plan = action.payload.isActivePlan;
                // You could also update other fields if needed
            }
        }
        // --- END: ADD THIS NEW REDUCER ---
    }
})

const SubscriptionSlice=createSlice({
    name:"SubscriptionSlice",
    initialState: {
        subscription: null,
    },
    reducers:{
        setSubscription(state, action) {
            state.subscription = action.payload;
        },
        // --- START: ADD THIS NEW REDUCER ---
        updateSubscriptionStatus(state, action) {
            if (state.subscription) {
                state.subscription.status = action.payload.subscriptionStatus;
                state.subscription.isPendingPayment = false; // Explicitly set this to false
            }
        }
        // --- END: ADD THIS NEW REDUCER ---
    }
})

export {ProfileSlice,SubscriptionSlice}

// --- START: EXPORT THE NEW ACTIONS ---
export const {ProfileRedu, updateUserPlanStatus}=ProfileSlice.actions
export const {setSubscription, updateSubscriptionStatus}=SubscriptionSlice.actions
// --- END: EXPORT THE NEW ACTIONS ---